import { useState, useEffect } from 'react';

interface UseImagePreloaderProps {
  images: string[];
}

interface UseImagePreloaderReturn {
  allImagesLoaded: boolean;
  loadedCount: number;
  totalCount: number;
  loadedImages: Set<string>;
}

export const useImagePreloader = ({ images }: UseImagePreloaderProps): UseImagePreloaderReturn => {
  const [loadedImages, setLoadedImages] = useState<Set<string>>(new Set());

  useEffect(() => {
    const loadImage = (src: string): Promise<void> => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          setLoadedImages(prev => new Set(prev.add(src)));
          resolve();
        };
        img.onerror = () => {
          // Still mark as "loaded" to prevent blocking
          setLoadedImages(prev => new Set(prev.add(src)));
          resolve();
        };
        img.src = src;
      });
    };

    const loadAllImages = async () => {
      const promises = images.map(loadImage);
      await Promise.all(promises);
    };

    if (images.length > 0) {
      loadAllImages();
    }
  }, [images]);

  return {
    allImagesLoaded: loadedImages.size === images.length,
    loadedCount: loadedImages.size,
    totalCount: images.length,
    loadedImages
  };
};